<template>
  <div>
    <div class="header">
      <a :href="globalConfig.kkLogoLink">
        <img :src="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/static/img/register/logo.svg' : '/static/img/register/email/status/KKBrand_Logo.png'">
      </a>
    </div>
    <div v-if="loading" class="loading">
      <van-loading size="48px" color="#FFFFFF" />
      <p>LOADING...</p>
    </div>
  </div>
</template>

<script>
import { sendRegister } from '@/api/official'
import { getFingerprint } from '@/configs/userStatsTrack'
import siteType from '@/configs/siteType'

export default {
  name: 'transition',
  data() {
    return {
      loading: false,
      siteType,
    }
  },
  created() {
    this.verifyEdmToken()
  },
  methods: {
    verifyEdmToken() {
      this.loading = true
      sendRegister({
        t: this.$route.query.t,
        v: this.$route.query.v,
      }).then((res) => {
        getFingerprint(this)
        let statusCode = res.code.toString();
        let pathName = "/failed"
        let hostId = res.invite_uid
        let clubId = res.invite_clubid
        this.loading = false
        // 0 - success, -16 - already verified
        if (res.code === 0 || res.code === -16) {
          pathName = "/verified"
          statusCode  = res.code
        }
        const queryParam = {
          lang: this.$i18n.locale,
          status: statusCode,
          cpr_code: res.cpr_code || '',
          registered_email: res.registered_email || ''
        }
        if(hostId !== 0 && clubId !== 0) {
          queryParam.hostId = hostId
          queryParam.clubId = clubId
        }
        this.$router.push({
          path: pathName,
          query: queryParam
        })
      }).catch(err => {
        this.loading = false
        this.$toast({
          message: err,
          className: 'register_toast'
        })
      })
    }
  }
}
</script>
<style lang="less">

body,
#default-layout {
  background-color: #050505;
  height: 100%;
}
html,
body,
#default-layout {
  height: 100%;
}

.register_toast {
  background-color: #000000;
  padding: 14px 10px;

  .van-toast__text {
    font-size: 24px;
    line-height: 30px;
    max-width: 550px;
  }
}
</style>
<style lang="less" scoped>
.header{
  height: 70px;
  width: 100%;
  background-color: #000000;
  img {
    position: absolute;
    left: 50px;
    top: 15px;
    width: 170px;
    height: auto;
  }
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh; 
  flex-direction: column;
  p{
    margin-top: 30px;
  }
}
</style>
